export const muv = [
  {
    id: 1,
    name: "Maruti Ertiga AC",
    body: "MUV",
    seats: "6 + 1",
    doors: "5",
    engine: "1462 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC",
    image: "/images/gallery/muv/ertiga.jpg",

    gallery: [
      "/images/gallery/muv/ertiga.jpg",
      "/images/gallery/muv/ertiga-interior.jpg",
      "/images/gallery/muv/ertiga-side.jpg",
      
    ]
  },
  {
    id: 2,
    name: "Toyota Rumion AC",
    body: "MUV",
    seats: "6 + 1",
    doors: "5",
    engine: "1462 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC",
    image: "/images/gallery/muv/Rumion.jpg",

    gallery: [
      "/images/gallery/muv/rumion.jpg",
      "/images/gallery/muv/rumion-interior.jpg",
      "/images/gallery/muv/rumion-back.jpg",
    
    ]
  },
  {
    id: 3,
    name: "Toyota Innova Crysta AC",
    body: "MUV",
    seats: "6 + 1",
    doors: "5",
    engine: "2494 cc",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC / Non-AC",
    image: "/images/gallery/muv/crysta.jpg",

    gallery: [
      "/images/gallery/muv/crysta.jpg",
      "/images/gallery/muv/crysta-interior.jpg",
      "/images/gallery/muv/crysta-front.jpg"
    ]
  },
  {
    id: 4,
    name: "Toyota Hycross AC",
    body: "MUV",
    seats: "7 + 1",
    doors: "5",
    engine: "1987 cc",
    transmission: "Automatic (Hybrid)",
    fuel: "Petrol / Hybrid",
    ac: "AC",
    image: "/images/gallery/muv/hycross.jpg",

    gallery: [
      "/images/gallery/muv/hycross.jpg",
      "/images/gallery/muv/hycross-interior.jpg",
      "/images/gallery/muv/hycross-tyre.jpg",

    ]
  },
//   {
//     id: 5,
//     name: "Toyota Fortuner AC",
//     body: "SUV",
//     seats: "7",
//     doors: "5",
//     engine: "2755 cc",
//     transmission: "Manual / Automatic",
//     fuel: "Diesel",
//     ac: "AC",
//     image: "/images/gallery/muv/fortuner.jpg",

//     gallery: [
//       "/images/gallery/muv/fortuner.jpg",
//       "/images/fortuner/interior.jpg",
//       "/images/fortuner/rear.jpg"
//     ]
//   }
];
